import { render, staticRenderFns } from "./MediaCenters.vue?vue&type=template&id=320d5c22&scoped=true&lang=pug&"
import script from "./MediaCenters.vue?vue&type=script&lang=ts&"
export * from "./MediaCenters.vue?vue&type=script&lang=ts&"
import style0 from "./MediaCenters.vue?vue&type=style&index=0&id=320d5c22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d5c22",
  null
  
)

export default component.exports